<template>
  <!-- Navbar #0d4f78 -->
  <header class="navbar-sticky box-shadow-sm" style="background-color: #FFFFFF;">
    <div class="navbar navbar-expand-lg navbar-light py-1">
      <div class="container px-lg-5">
        <!-- Logo -->
        <a class="navbar-brand d-none d-sm-block mr-4 order-lg-1 bg-light" href="/" style="min-width: 7rem;">
          <img width="172" src="img/myDesigns/pictures/header-lg.svg" alt="wirkaufendeine-kueche.de"/>
        </a>
        <a class="navbar-brand d-sm-none mr-2 order-lg-1" href="/" style="min-width: 4.625rem;">
          <img width="114" src="img/myDesigns/pictures/header-lg.svg" alt="wirkaufendeine-kueche.de"/>
        </a>
        <!-- Toolbar Always-->
        <div class="navbar-toolbar d-flex align-items-center order-lg-3">
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse">
            <span class="navbar-toggler-icon"></span>
          </button>
          <button class="navbar-tool ml-1 mr-n1 btn btn-outline-secondary" @click="scrollToEval">
            Jetzt bewerten
          </button>
          <div class="navbar-tool dropdown ml-3 d-none d-sm-inline-block">
            <a class="navbar-tool-icon-box dropdown-toggle" data-toggle="dropdown">
              <div class="navbar-tool-icon-box">
                <i class="navbar-tool-icon czi-chat font-size-md mt-1" style="color: gray"></i>
              </div>
            </a>
            <div class="dropdown-menu dropdown-menu-right text-center py-3 px-2" style="width: 16rem;">
              <i class="czi-chat h5 mb-0 font-weight-normal text-dark mb-3"></i>
              <div class="text-dark font-size-sm h6 mb-0">Persönliche Hilfe</div>
              <a class="nav-link-style text-dark font-size-md" target="_blank" href="mailto:mail@wirkaufendeine-kueche.de">
                mail@wirkaufendeine-kueche.de
              </a>
            </div>
          </div>
        </div> 
        <!-- Toolbar Collapse-->
        <div class="collapse navbar-collapse mr-auto order-lg-2" id="navbarCollapse">
          <ul class="navbar-nav">
            <li class="nav-item">
              <a class="nav-link text-dark" data-toggle="dropdown" style="cursor: pointer" @click="scrollToEval">Bewerten</a>
            </li>
            <li class="nav-item dropdown active">
              <a class="nav-link dropdown-toggle text-dark" data-toggle="dropdown" style="cursor: pointer">
                Services 
                <!--<i class="czi-arrow-down font-size-xs text-dark d-xl-none"></i>-->
              </a>
              <ul class="dropdown-menu">
                <li class="dropdown position-static mb-0">
                  <a class="dropdown-item py-2 border-bottom" @click="routeToMarket" style="cursor: pointer">
                    <span class="d-block text-heading">Gebrauchtküchen inkl. Aufbau</span>
                  </a>
                </li>
                <li class="dropdown position-static mb-0">
                  <a class="dropdown-item pt-3" target="_blank" href="https://www.check24.de/kredit/kueche-finanzieren/">
                    <span class="d-block text-heading">Küchenfinanzierung finden</span>
                  </a>
                </li>
              </ul>
            </li>
            <li class="nav-item dropdown active">
              <a class="nav-link text-dark" data-toggle="dropdown" @click="scrollToFaq" style="cursor: pointer">Informieren</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header> 
</template>

<script>
export default {
  name: 'navbar',
  components: {
  },
  props: {
    evalExtern: {
      type: Boolean,
      default: false
    },
    informExtern: {
      type: Boolean,
      default: false
    } 
  },
  data: () => ({
  }),
  computed: {
  },
  created: function () {
  },
  mounted: function () {
  },
  methods: {
    scrollToEval: function () {
      if (this.evalExtern) {
        this.$router.push({path: "/"});
        return;
      }
      const id = "evaluationCard";
      let element = document.getElementById(id);
      if (element !== null) {
        element.scrollIntoView();
      }
    },
    scrollToFaq: function () {
      if (this.informExtern) {
        this.$router.push({path: "/"});
        return;
      } 
      const id = "faqCard";
      let element = document.getElementById(id);
      if (element !== null) {
        element.scrollIntoView();
      }
    }, 
    routeToMarket: function () {
      this.$router.push({path: "marktplatz"});
    }
  }
}
</script>